export default __webpack_public_path__ + "static/media/462.f047eb30.png";